import { render, staticRenderFns } from "./ChangeOfStatusNotify.vue?vue&type=template&id=f3241508&scoped=true"
import script from "./ChangeOfStatusNotify.vue?vue&type=script&lang=js"
export * from "./ChangeOfStatusNotify.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfStatusNotify.vue?vue&type=style&index=0&id=f3241508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3241508",
  null
  
)

export default component.exports